export const readFile = (file, setFile, updateProgress) => {
	const reader = new FileReader();

	reader.onabort = () => console.log('file reading was aborted');
	reader.onerror = () => console.log('file reading has failed');
	reader.onprogress = updateProgress;
	reader.onload = () => {
		// Do whatever you want with the file contents
		const binary = reader.result.split(',')[1];
		setFile(binary);
	};

	reader.readAsDataURL(file);
};
